import { render, staticRenderFns } from "./staff-chartd.vue?vue&type=template&id=355cf0a1"
import script from "./staff-chartd.vue?vue&type=script&lang=ts"
export * from "./staff-chartd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports